import React from 'react';
import './CustomToolTip.scss';

var abrMonthNames = [
  'Jan', 'Feb', 'Mar',
  'Apr', 'May', 'Jun', 'Jul',
  'Aug', 'Sep', 'Oct',
  'Nov', 'Dec',
];

function formatDate(date) {
  
  var day = date.getDate();
  var monthIndex = date.getMonth() + 1;

  return monthIndex + '/' + day;
}

export default function CustomToolTip(props) {
  let { payload } = props;

  if (payload && payload.length > 0) {
    payload = payload[0].payload;
    const left = (props.coordinate.x - 50);
    const top = props.viewBox.top - 5;
    let toolTipText = '';
    switch (payload.timePeriodLabel) 
    {
    case 'MONTHS':
      toolTipText = abrMonthNames[payload.startTime.getMonth()] + ' ' + payload.startTime.getFullYear();
      break;
    case 'WEEKS':
      toolTipText = formatDate(payload.startTime) + '-' + formatDate(payload.endTime);
      break;
    case 'DAYS':
      toolTipText = formatDate(payload.startTime);
      break;
    case 'HOURS':
      toolTipText = payload.startTime.getHours() + ':00';
      break;
    default:
      toolTipText = formatDate(payload.startTime);
      break;
    }
    return (
      <div className="project-custom-tooltip" key={payload.startTime.getTime()} style={{ left: left, top: top }}>
        <div className="project-custom-tooltip-date">{toolTipText}</div>
      </div>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/ProjectTimeline/CustomToolTip/index.js